import { mutateData, uploadFile } from '../services/mutateData';

export async function createScreen(
  title: string,
  tenantId: string,
  companyId: string,
  body: any,
  screenId?: string,
  folder?: string
) {
  const res = screenId
    ? await mutateData(
        'PUT',
        `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/screens/${screenId}/update-screen?title=${title}&folder=${folder}`,
        body
      )
    : await mutateData(
        'POST',
        `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/screens/upload-screen?title=${title}&folder=${folder}`,
        body
      );
  if (!res) {
    return {
      message: 'Ops! Something went wrong. Please try again.',
    };
  }

  if (res.error) {
    return {
      error: 'Failed to create.',
    };
  }

  return {
    message: 'Screen created',
    data: res,
  };
}

export async function deleteLog(
  tenantId: string,
  companyId: string,
  screenId: string,
  id: number
) {
  const res = await mutateData(
    'DELETE',
    `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/screens/${screenId}/history/${id}`,
    {}
  );

  if (!res) {
    return {
      message: 'Ops! Something went wrong. Please try again.',
    };
  }

  if (res.error) {
    return {
      message: 'Failed to delete log.',
    };
  }

  return {
    message: 'Log deleted',
    data: res,
  };
}

export async function restoreVersion(
  tenantId: string,
  companyId: string,
  screenId: string,
  id: number
) {
  const res = await mutateData(
    'PUT',
    `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/screens/${screenId}/history/${id}/restore`,
    {}
  );

  if (!res) {
    return {
      message: 'Ops! Something went wrong. Please try again.',
    };
  }

  if (res.error) {
    return {
      message: 'Failed to restore version.',
    };
  }

  return {
    message: 'Version restored',
    data: res,
  };
}

export async function publishVersion(
  tenantId: string,
  companyId: string,
  screenId: string,
  id: number
) {
  const res = await mutateData(
    'PATCH',
    `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/screens/${screenId}/history/${id}/publish`,
    {}
  );

  if (!res) {
    return {
      message: 'Ops! Something went wrong. Please try again.',
    };
  }

  if (res.error) {
    return {
      message: 'Failed to publish version.',
    };
  }

  return {
    message: 'Version published',
    data: res,
  };
}

export async function uploadImage(
  tenantId: string,
  companyId: string,
  file: any
) {
  let body = new FormData();
  body.append('file', file);

  const res = await uploadFile(
    'POST',
    `${process.env.NEXT_PUBLIC_API_URL}/tenants/${tenantId}/companies/${companyId}/documents/screens/upload-image`,
    body
  );
  if (!res) {
    return {
      message: 'Ops! Something went wrong. Please try again.',
    };
  }

  if (res.error) {
    return {
      message: 'Failed to upload image.',
    };
  }

  return {
    message: 'Image uploaded',
    data: res,
  };
}
